'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _lodash = require('lodash');

function formatIn(value) {
  if (Array.isArray(value) && !(0, _lodash.isEmpty)(value)) {
    var realValue = value[value.length - 1].value;
    return realValue;
  }
  return value;
}

function formatOut(value, data) {
  var extra = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var selectedPath = extra.selectedPath;

  if ((0, _lodash.isEmpty)(selectedPath)) {
    return [];
  }
  return selectedPath.map(function (item) {
    return {
      text: item.label,
      value: item.value
    };
  });
}

function defaultValueFormatter(value) {
  if ((0, _lodash.isEmpty)(value)) {
    return '';
  } else {
    return value.map(function (item) {
      if ((0, _lodash.isObject)(item) && !(0, _lodash.isNil)(item)) {
        return item.text;
      }
      return item;
    }).join('/');
  }
}

function fieldDataFormatter(value, options, state) {
  if (Array.isArray(value) && !(0, _lodash.isEmpty)(value)) {
    var result = [];
    value.reduce(function (opts, val) {
      var item = !(0, _lodash.isEmpty)(opts) && opts.find(function (it) {
        return it.value == ((typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object' ? val.value : val);
      });
      if (item && (!val || (0, _lodash.isEmpty)(val.text) || val.text === val.value)) {
        result.push({
          text: item.text || item.label,
          value: item.value
        });
        return item.children;
      } else {
        result.push(val);
        return [];
      }
    }, options);
    return result;
  }
  return value;
}

exports.default = {
  formatIn: formatIn,
  formatOut: formatOut,
  defaultValueFormatter: defaultValueFormatter,
  fieldDataFormatter: fieldDataFormatter
};
module.exports = exports['default'];